import ProgressBar from "@ramonak/react-progress-bar";
import { Card, Col, List, Row, Skeleton, Steps, Space, Spin } from "antd";
import { memo, useEffect, useRef, useState } from "react";
import { BiChevronDown, BiChevronRight, BiChevronUp, BiPlayCircle } from "react-icons/bi";
import { IoIosCheckboxOutline, IoMdCheckbox } from "react-icons/io";
import { IoRadioButtonOffSharp, IoRadioButtonOn } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import { EventMiddleware } from "../../../../../Store/Middlewares/EventMiddleware";
import peopleImg from "../../../../../assets/people1.png";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import styles from "./SinglePlanningForm.module.css";
import dummy from "../../../../../assets/dummy.png";
import { getClientQuestion } from "../../../../../Store/Actions/EventAction";
import { AiFillCheckSquare, AiFillDelete, AiFillHeart, AiFillPlaySquare, AiFillPlusCircle, AiFillRightSquare, AiFillYoutube, AiOutlineArrowRight, AiOutlineBorder, AiOutlineDownSquare, AiOutlineHeart, AiOutlineLeftSquare, AiOutlineRightSquare, AiOutlineUpSquare } from "react-icons/ai";
import { MdAdd } from "react-icons/md";
import Meta from "antd/es/card/Meta";
import dummyImg from "../../../../../assets/dummy.jpg";
import { PlaylistMiddleware } from "../../../../../Store/Middlewares/PlaylistMiddleware";
import Modal from "../../../../../components/modal/Modal";
import { redirectToSpotifyAuth } from "../../../../../utills/spotifyAuth";
import { BsSpotify } from "react-icons/bs";
import { GiLoveSong } from "react-icons/gi";
import Storage from "../../../../../utills/AsyncStorage";

const description = "This is a description.";

const planningItems = [
  {
    title: "General",
    progress: 75,
  },
  {
    title: "Photography",
    progress: 100,
  },
  {
    title: "Decoration",
    progress: 100,
  },
  {
    title: "DJ",
    progress: 100,
  },
];

const RenderPlanningItem = memo(
  ({ title, progress, setTopic, item, getClientQueston }) => {
    return (
      <List.Item
        className={styles.itemRow}
        onClick={() => {
          getClientQueston(item?.id);
          setTopic(item);
        }}
      >
        <Col xs={20}>
          <Row>
            <TextComponent textClass={styles.itemTitle}>{title}</TextComponent>
          </Row>
          <Row className={styles.progressBarRow}>
            <ProgressBar
              completed={progress}
              className={styles.bar}
              maxCompleted={100}
              labelClassName={styles.labelBar}
              bgColor="var(--primary-color)"
              height="6px"
            />
            <TextComponent textClass={styles.progressText}>
              {parseInt(progress)}%
            </TextComponent>
          </Row>
        </Col>
        <Col xs={4} className={styles.iconCol}>
          <BiChevronRight style={{ fontSize: "2rem" }} />
        </Col>
      </List.Item>
    );
  }
);

const RenderQuestion = memo(({ item, index, setQuestions }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // let ownwords = answerByClient?.find(
  //   (element) => element?.question_id == item.id
  // );

  // let isAnswered = item?.answer?.length > 0 ? true : false;
  // console.log(item);
  return (
    <List.Item className={styles.rightColRow}>
      <Col xs={24}>
        <Row className={styles.questionRow}>
          <Col xs={22}>
            <Row className={styles.question}>
              <TextComponent textClass={styles.questionText}>
                <TextComponent textClass={styles.prefix}>
                  {item.prefix}
                </TextComponent>
                &nbsp;
                {item?.question} #{index + 1}
              </TextComponent>
            </Row>
            {dropdownOpen && (
              <div className={styles.optionsContainer}>
                {item.type == "set_option" &&
                  item?.options?.map((option) => {
                    let findAnswer = option.name == item.answer ? true : false;
                    return (
                      <Row className={styles.option} key={option?.id}>
                        <Col style={{ flex: 1 }}>
                          <Row
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setQuestions((prev) => {
                                let cpy = [...prev];
                                cpy.splice(index, 1, {
                                  ...item,
                                  answer: option.name,
                                  answerUpdate: true,
                                });
                                return cpy;
                              })
                            }
                          >
                            <Col xs={1}>
                              {findAnswer ? (
                                <IoRadioButtonOn
                                  size={30}
                                  color="var(--primary-color)"
                                />
                              ) : (
                                <IoRadioButtonOffSharp
                                  size={30}
                                  color="var(--primary-color)"
                                />
                              )}
                            </Col>
                            <Col xs={22}>
                              <TextComponent textClass={styles.optionText}>
                                {option?.name}
                              </TextComponent>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}

                {item.type == "multiple_option" &&
                  item?.options?.map((option) => {
                    let findAnswer = item.answer?.includes(option?.name);
                    return (
                      <Row className={styles.option} key={option?.id}>
                        <Col style={{ flex: 1 }}>
                          <Row
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setQuestions((prev) => {
                                let cpy = [...prev];
                                cpy.splice(index, 1, {
                                  ...item,
                                  answer: item?.answer?.includes(option.name)
                                    ? item?.answer?.filter(
                                      (data) => data != option.name
                                    )
                                    : item.answer?.length > 0
                                      ? [...item.answer, option.name]
                                      : [option.name],

                                  answerUpdate: true,
                                });
                                return cpy;
                              })
                            }
                          >
                            <Col xs={1}>
                              {findAnswer ? (
                                <IoMdCheckbox
                                  size={30}
                                  color="var(--primary-color)"
                                />
                              ) : (
                                <IoIosCheckboxOutline
                                  size={30}
                                  color="var(--primary-color)"
                                />
                              )}
                            </Col>
                            <Col xs={22}>
                              <TextComponent textClass={styles.optionText}>
                                {option?.name}
                              </TextComponent>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                {item.type === "own_words" && (
                  <textarea
                    rows={5}
                    value={item.answer}
                    className={styles.textInput}
                    placeholder="Type Here"
                    onChange={(e) =>
                      setQuestions((prev) => {
                        let cpy = [...prev];
                        cpy.splice(index, 1, {
                          ...item,
                          answer: e.target.value,
                          answerUpdate: true,
                        });
                        return cpy;
                      })
                    }
                  ></textarea>
                )}
              </div>
            )}
          </Col>
          <Col xs={2} className={styles.iconCol}>
            <TextComponent
              textClass={styles.dropdownArrow}
              onClick={() => setDropdownOpen((prev) => !prev)}
            >
              {dropdownOpen ? (
                <BiChevronUp className={styles.dropdownIcon} />
              ) : (
                <BiChevronDown className={styles.dropdownIcon} />
              )}
            </TextComponent>
          </Col>
        </Row>
      </Col>
    </List.Item>
  );
});

const QuestionSteps = ({
  loading,
  ClientQuestion,
  setQuestions,
  getSection,
}) => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const dispatch = useDispatch();
  const planingForm = useLocation().state?.item;

  const onPressDone = () => {
    if (!ClientQuestion?.find((item) => item.answerUpdate)) {
      dispatch(
        showAlert({
          title: "Post answer by clien",
          message: "No changes made!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else {
      dispatch(
        EventMiddleware.postAnswerByClient({
          answerCollection: ClientQuestion,
          planningtemplate_id: planingForm?.id,
          event_id: EventDetails?.id,
        })
      ).then(() => getSection(false));
      // .catch((err) => console.log(err));
    }
  };

  return (
    <Skeleton loading={loading}>
      <Steps
        direction="vertical"
        current={ClientQuestion.length - 1}
        style={{ margin: "40px auto 20px auto" }}
      >
        {ClientQuestion.map((item, index) => (
          <Steps.Step
            key={item.id}
            // title="In Progress"
            title={
              <RenderQuestion
                item={item}
                index={index}
                setQuestions={setQuestions}
              />
            }
            icon={
              <svg
                width="20"
                height="20"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.433594 17.7695C0.433594 8.21132 8.18788 0.457031 17.7461 0.457031C27.3043 0.457031 35.0586 8.21132 35.0586 17.7695C35.0586 27.3277 27.3043 35.082 17.7461 35.082C8.18788 35.082 0.433594 27.3277 0.433594 17.7695ZM17.7461 3.12049C9.65887 3.12049 3.09706 9.68231 3.09706 17.7695C3.09706 25.8568 9.65887 32.4186 17.7461 32.4186C25.8333 32.4186 32.3951 25.8568 32.3951 17.7695C32.3951 9.68231 25.8333 3.12049 17.7461 3.12049Z"
                  fill="var(--primary-color)"
                />
                <path
                  d="M17.7524 28.9305C23.9172 28.9305 28.9149 23.9329 28.9149 17.768C28.9149 11.6031 23.9172 6.60547 17.7524 6.60547C11.5875 6.60547 6.58984 11.6031 6.58984 17.768C6.58984 23.9329 11.5875 28.9305 17.7524 28.9305Z"
                  fill="var(--primary-color)"
                />
              </svg>
            }
          />
        ))}
      </Steps>

      <SubmitButton
        title={"Submit"}
        btnClass={styles.submitBtn}
        onClick={onPressDone}
      />
    </Skeleton>
  );
};

const SinglePlanningForm = () => {
  const [topic, setTopic] = useState("");
  const [loading, setloading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const ClientSection = useSelector(
    (state) => state.EventReducer.ClientSubSection
  );
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const Playlist = useSelector(
    state => state.PlaylistReducer?.SongsList,
  );
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [songsList, setsongsList] = useState([])
  const routeData = state?.item;
  const [showQuestionList, setshowQuestionList] = useState(false)

  //Add Songs
  const [songIdeasModal, setsongIdeasModal] = useState(false);
  const [songIdeas, setsongIdeas] = useState([]);
  const [songIdeasList, setsongIdeasList] = useState([]);
  const [songIdeasListModal, setsongIdeasListModal] = useState(false);
  const [addSongModal, setaddSongModal] = useState(false);
  const [searchYoutubeModal, setsearchYoutubeModal] = useState(false);
  const [YoutubeSongs, setYoutubeSongs] = useState([])
  const [title, setTitle] = useState('');
  const [isSearch, setisSearch] = useState(false)
  let timeOut = useRef(null);
  const token = localStorage.getItem('access_token');
  const [isSpotify, setisSpotify] = useState(false)
  const [spotifyPlaylist, setSpotifyPlaylist] = useState([])
  const [spotifysongsModal, setSpotifySongsModal] = useState(false)
  const [spotifysongs, setSpotifySongs] = useState([])
  const [isAdd, setisAdd] = useState(null)

  const [SelectedPlaylist, setSelectedPlaylist] = useState([])
  const [isMultiselect, setisMultiselect] = useState(false)
  const [isUpload, setisUpload] = useState(false)
  const [playlistSongs, setplaylistSongs] = useState([])
  const [loader, setLoader] = useState(false);
  console.log('ClientSection',ClientSection)
  console.log('topic',topic)
  //Add Songs
  useEffect(() => {
    getSection();
  }, []);

  const getClientQueston = (id) => {
    setloading(true);
    let secdata = {
      templatesection_id: id,
      event_id: EventDetails?.id,
    };
    dispatch(EventMiddleware.getClientQuestions(secdata))
      .then((data) => {
        setsongsList(data.musics)
        setQuestions(data?.questions);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
        // console.log(err);
      });
  };
  // console.log("routeData", routeData);
  const getSection = (getQuestions = true) => {
    let tempData = {
      id: routeData?.id,
      event_id: EventDetails?.id,
    };
    dispatch(EventMiddleware.getSubSections(tempData)).then((data) => {
      if (data?.length > 0) {
        setTopic(topic ? topic : data?.[0]);
        if (getQuestions) {
          getClientQueston(topic?.id ? topic?.id : data?.[0]?.id);
        }
      } else {
        dispatch(getClientQuestion([]));
      }
    });
  };

  const openYouTubeVideo = (videoId) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  const addYoutubeSong = (item) => {
    setisAdd(item?.id?.videoId ? item?.id?.videoId : item?.id)
    dispatch(PlaylistMiddleware.addSectionSongs({ section_id: topic?.id, name: item?.snippet?.title ? item?.snippet?.title : item?.name, image: item?.snippet?.thumbnails?.default?.url ? item?.snippet?.thumbnails?.default?.url : item?.image, description: item?.snippet?.description ? item?.snippet?.description : item?.description, type: 'youtube', video_id: item?.id?.videoId ? item?.id?.videoId : item?.video_id, event_id: EventDetails?.id })).then((data) => {
      setsongsList(data)
      setisAdd(null)
    }).catch(() => { setisAdd(null) })
  }

  const SearchYoutube = (val) => {
    setTitle(val)
    setisSearch(true)
    clearTimeout(timeOut.current)
    timeOut.current = setTimeout(() => {
      if (val) {
        dispatch(PlaylistMiddleware.getYoutubeSongs({ name: val })).then((data) => {
          setisSearch(false)
          if (val) {
            setYoutubeSongs(data?.items)
          } else {
            setYoutubeSongs([])
          }

        }).catch(() => setisSearch(false))
      } else {
        setYoutubeSongs([])
        setisSearch(false)
      }
    }, 1500);

  }

  const connectSpotify = async () => {
    if (!token) {
      redirectToSpotifyAuth();
      return;
    } else {
      const isTokenExpired = () => {
        const expiresAt = localStorage.getItem("expires_at");
        return !expiresAt || Date.now() > parseInt(expiresAt);
      };
      if (isTokenExpired()) {
        const refreshToken = localStorage.getItem("refresh_token");
        const response = await fetch("https://accounts.spotify.com/api/token", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            grant_type: "refresh_token",
            refresh_token: refreshToken,
            client_id: "cbd536439be2450aa0709cb1c39ffcba",
          }),
        });

        const data = await response.json();
        const expiresIn = data.expires_in; // usually 3600 seconds
        const expiresAt = Date.now() + expiresIn * 1000;

        localStorage.setItem("refresh_token", data.refresh_token);
        localStorage.setItem("expires_at", expiresAt);
        localStorage.setItem("access_token", data.access_token);
        getPlaylist()
        // token expired — refresh it or ask user to re-login
      } else {
        // safe to use token
        getPlaylist()
      }
    }
  };

  const getPlaylist = () => {
    dispatch(PlaylistMiddleware.getSpotifyPlaylist({})).then((data) => {
      setaddSongModal(false)
      setSpotifyPlaylist(data?.items)
      setisSpotify(true)
    }).catch(() => setisSpotify(true))
  }

  const getPlaylistSongs = (id) => {
    setisSpotify(false)
    setisAdd(id)
    dispatch(PlaylistMiddleware.getSpotifyPlaylistSongs({ id })).then((data) => {
      setSpotifySongs(data?.items)
      setSpotifySongsModal(true)
      setisAdd(null)
    })
  }

  const searchSong = (item) => {
    setisAdd(item.track.id)
    const trackName = item?.track?.name;
    const artistNames = item?.track.artists.map(a => a.name).join(' ');
    const youtubeSearchQuery = `${trackName} ${artistNames} ${item?.track?.external_ids?.isrc}`;
    dispatch(PlaylistMiddleware.getYoutubeSongs({ name: youtubeSearchQuery })).then((data) => {
      addSpotifySong(data.items[0])
    })

  }

  const addSpotifySong = (item) => {
     dispatch(PlaylistMiddleware.addSectionSongs({ section_id: topic?.id, name: item?.snippet?.title, image: item?.snippet?.thumbnails?.default?.url, description: item?.snippet?.description, type: 'youtube', video_id: item?.id?.videoId,event_id: EventDetails?.id })).then((data) => {
      setisAdd(null);
      setsongsList(data);
    }).catch(() => { setisAdd(null); setisSpotify(false) })
  }

  const uploadBulkSongs = () => {
    if (SelectedPlaylist.length > 0) {
      setisUpload(true)
      dispatch(PlaylistMiddleware.createTemplateSectionSongs({ Queries: SelectedPlaylist, id: topic?.id, event_id: EventDetails?.id })).then((data) => {
        setisUpload(false)
        // setisSpotify(false)
        // setisPlaylist(false)
        setisMultiselect(false)
        setsongsList(data)
        setSelectedPlaylist([])
      }).catch(() => {
        setisUpload(false)
      })
    }
  }

  const uploadBulkSongsIdeas = () => {
    if (SelectedPlaylist.length > 0) {
      setisUpload(true)
      dispatch(PlaylistMiddleware.bulkUploadSectionSongs({ section_id: topic?.id, event_id: EventDetails?.id, songs: SelectedPlaylist })).then((data) => {
        setisUpload(false)
        // setisSpotify(false)
        // setisPlaylist(false)
        setisMultiselect(false)
        setsongsList(data)
        setSelectedPlaylist([])
      }).catch(() => {
        setisUpload(false)
      })
    }
  }
  const renderSongsList = (item) => {
    return (
      <List.Item
      >
        <Card
          hoverable
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <img
              className={styles.image}
              src={item?.image ? item?.image : dummyImg}
              alt="example"
            />
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  text={item.name ? item.name : '--'}
                  textClass={styles.songsText}
                />
              </>
            }
            description={<TextComponent text={item?.description} textClass={styles.songsText} />}
          />

          <Col className={styles.addSongModal}>
            <div className={styles.addSongModalDiv}
              onClick={() => {
                dispatch(PlaylistMiddleware.updateSectionSongLikeStatus({ id: item.id })).then((data) => {
                  setsongsList(data)
                })
              }}
            >
              {item?.is_like == 1 ?
                <AiFillHeart color="red" size={20} />
                :
                <AiOutlineHeart color="#00000" size={20} />
              }
            </div>

            <div onClick={() => {
              dispatch(PlaylistMiddleware.deleteSectionSongs({ id: item.id })).then((data) => {
                setsongsList(data)
              })
            }} className={styles.addSongModalDiv}>
              <AiFillDelete color="#00000" size={20} />
            </div>

            <div onClick={() => { openYouTubeVideo(item?.video_id); }} className={styles.addSongModalDiv}>
              <BiPlayCircle color="#00000" size={20} />
            </div>

          </Col>


        </Card>
      </List.Item>
    );
  }
  const renderSongIdeas = (item) => {
    return (
      <List.Item
      >
        <Card
          onClick={() => {
            setisAdd(item.id)
            dispatch(PlaylistMiddleware.getPlaylistSongs({ id: item.id })).then((data) => {
              setplaylistSongs(data)
              setsongIdeasModal(false)
              setsongIdeasListModal(true)
              setisAdd(null)
            }).catch()
          }}
          hoverable
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <img
              className={styles.image}
              src={item?.image ? item?.image : dummyImg}
              alt="example"
              resizeMode="contain"
            />
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  text={item?.name ? item?.name : '--'}
                  textClass={styles.songsText}
                />
              </>
            }
          // description={<TextComponent text={item?.track.artists.map(a => a.name).join(', ')}
          //   textClass={styles.songsText} />}
          />
          {isAdd == item?.id ? <Spin size="large" /> :
            <Col className={styles.addSongModal}>
              <div className={styles.addSongModalDiv}>
                <AiFillRightSquare color="#00000" size={20} />
              </div>
            </Col>

          }

        </Card>
      </List.Item>
    );
  }
  const renderSongIdeasList = (item) => {
    let find = songsList.find((it) => it?.video_id == item?.video_id)
    let FindMulti = SelectedPlaylist.find(it => it?.video_id == item?.video_id)
    return (
      <List.Item
      >
        <Card
          hoverable
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <img
              className={styles.image}
              src={item?.image ? item?.image : dummyImg}
              alt="example"
              resizeMode="contain"
            />
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  text={item?.name ? item?.name : '--'}
                  textClass={styles.songsText}
                />
              </>
            }
          // description={<TextComponent text={item?.track.artists.map(a => a.name).join(', ')}
          //   textClass={styles.songsText} />}
          />
          {isAdd == item?.id ? <Spin size="large" /> :
            !find && !isMultiselect &&
            <Col className={styles.addSongModal}>
              <div onClick={() => addYoutubeSong(item)} className={styles.addSongModalDiv}>
                <AiFillPlusCircle color="#00000" size={20} />
              </div>
              {/* <div onClick={() => openYouTubeVideo(item)} className={styles.addSongModalDiv}>
                <AiFillPlaySquare color="#00000" size={20} />
              </div> */}
            </Col>
          }
          {isMultiselect && !find &&
            <div
              // disabled={isUpload}
              onClick={() => {
                if (FindMulti) {
                  let data = [...SelectedPlaylist]
                  let index = data.findIndex(it => it?.track?.id == item?.track?.id)
                  data.splice(index, 1)
                  setSelectedPlaylist(data)
                } else {
                  let data = [...SelectedPlaylist]
                  data.push(item)
                  setSelectedPlaylist(data)
                }
              }}
            >
              {FindMulti ?
                <AiFillCheckSquare color="#00000" size={20} />
                :
                <AiOutlineBorder color="#00000" size={20} />}
            </div>
          }


        </Card>
      </List.Item>
    );
  }
  const renderYoutubeSongs = (item) => {
    let find = Playlist.find((it) => it?.video_id == item?.id?.videoId)

    return (
      <List.Item
      >

        <Card
          hoverable
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <img
              className={styles.image}
              src={item?.snippet?.thumbnails?.default?.url ? item?.snippet?.thumbnails?.default?.url : dummyImg}
              alt="example"
              resizeMode="contain"
            />
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  text={item?.snippet?.title ? item?.snippet?.title : '--'}
                  textClass={styles.songsText}
                />
              </>
            }
          // description={<TextComponent text={item.description} />}
          />

          {isAdd == item?.id?.videoId ? <Spin size="large" /> :
            !find &&
            <Col className={styles.addSongModal}>
              <div onClick={() => { addYoutubeSong(item) }} className={styles.addSongModalDiv}>
                <AiFillPlusCircle color="#00000" size={20} />

              </div>
              <div onClick={() => { openYouTubeVideo(item?.id?.videoId); }} className={styles.addSongModalDiv}>
                <BiPlayCircle color="#00000" size={30} />
              </div>

            </Col>

          }
        </Card>
      </List.Item>
    )
  }

  const renderSpotifyPlaylists = (item) => {

    return (
      <List.Item
      >
        {loader ? (
          <Space
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Skeleton.Image active className={styles.image} />
            <Skeleton.Input active size={20} />
          </Space>
        ) : (
          <Card
            onClick={() => getPlaylistSongs(item?.id)}
            hoverable
            style={{ width: "100%", textAlign: "center", alignItems: "center" }}
            cover={
              <img
                className={styles.image}
                src={item?.images?.length > 0 ? item?.images[0].url : dummyImg}
                alt="example"
                resizeMode="contain"
              />
            }
          >
            <Meta
              style={{ textAlign: "center" }}
              title={
                <>
                  <TextComponent
                    text={item.name ? item.name : '--'}
                    textClass={styles.songsText}
                  />
                </>
              }
            // description={<TextComponent text={item.description} />}
            />

            {isAdd == item?.id ? <Spin size="large" /> :
              <Col className={styles.addSongModal}>
                <div className={styles.addSongModalDiv}>
                  <AiOutlineArrowRight color="#00000" size={20} />
                </div>
              </Col>

            }
          </Card>
        )}
      </List.Item>
    );
  }
  const renderSpotifySongs = (item) => {
    let find = songsList.find((it) => it?.name.includes(item?.track?.name))
    let FindMulti = SelectedPlaylist.find(it => it?.track?.id == item?.track?.id)


    return (
      <List.Item
      >
        
          <Card
            hoverable
            style={{ width: "100%", textAlign: "center", alignItems: "center" }}
            cover={
              <img
                className={styles.image}
                src={item?.track?.album?.images?.length > 0 ? item?.track?.album?.images[0].url : dummyImg}
                alt="example"
                resizeMode="contain"
              />
            }
          >
            <Meta
              style={{ textAlign: "center" }}
              title={
                <>
                  <TextComponent
                    text={item?.track?.name ? item?.track?.name : '--'}
                    textClass={styles.songsText}
                  />
                </>
              }
              description={<TextComponent text={item?.track.artists.map(a => a.name).join(', ')}
                textClass={styles.songsText} />}
            />
            {isAdd == item.track.id ? <Spin size="large" /> :
              !find && !isMultiselect &&
              <Col className={styles.addSongModal}>
                <div onClick={() => searchSong(item)} className={styles.addSongModalDiv}>
                  <AiFillPlusCircle color="#00000" size={20} />
                </div>
              </Col>

            }
            {/* {isUpload && <> */}
            {isMultiselect && 
              <div
                // disabled={isUpload}
                onClick={() => {
                  if (FindMulti) {
                    let data = [...SelectedPlaylist]
                    let index = data.findIndex(it => it?.track?.id == item?.track?.id)
                    data.splice(index, 1)
                    setSelectedPlaylist(data)
                  } else {
                    let data = [...SelectedPlaylist]
                    data.push(item)
                    setSelectedPlaylist(data)
                  }
                }}
              >
                {FindMulti ?
                  <AiFillCheckSquare color="#00000" size={20} />
                  :
                  <AiOutlineBorder color="#00000" size={20} />}
              </div>
            }
            {/* </>} */}
          </Card>
      </List.Item>
    );
  }
  return (
    <Row>
      <Col xs={24} lg={8} className={styles.leftCol}>
        <Row className={styles.eventTitleRow}>
          <TextComponent textClass={styles.eventTitle}>
            {EventDetails?.name}
          </TextComponent>
        </Row>
        <Row className={styles.avatarRow} gutter={8}>
          <Col xs={6} sm={4}>
            <img
              src={routeData?.vendor_image ? routeData?.vendor_image : dummy}
              alt=""
              style={{ width: "100%", borderRadius: "100%" }}
            />
          </Col>
          <Col xs={18} sm={20}>
            <Row>
              <TextComponent textClass={styles.name}>
                {routeData?.vendor_name}
              </TextComponent>
            </Row>
            <Row>
              <TextComponent textClass={styles.profession}>
                {routeData?.vendor_category}
              </TextComponent>
            </Row>
          </Col>
        </Row>

        <List
          className={styles.planningItemsList}
          dataSource={ClientSection ? ClientSection : []}
          renderItem={(item) => (
            <RenderPlanningItem
              key={item?.id}
              title={item.name}
              item={item}
              getClientQueston={getClientQueston}
              progress={
                item?.total_question > 0
                  ? (parseInt(item?.total_answer_by_client) * 100) /
                  parseInt(item?.total_question)
                  : 0
              }
              setTopic={setTopic}
            />
          )}
        />
      </Col>

      <Col xs={24} lg={16} className={styles.rightCol}>
        <TextComponent textClass={styles.heading}>
          {topic?.name}
        </TextComponent>
        {topic?.is_music &&
          <>
            <Row className={styles.headingRow}>
              <Col>
                <div>
                  <TextComponent textClass={styles.headingNumbers}>
                    {ClientSection?.length > 0
                      ? `Songs (${songsList?.length}/${topic?.music_limit})`
                      : ""}
                  </TextComponent>
                </div>
              </Col>
              <Col>
                <SubmitButton
                  title="Add Songs"
                  leftIcon={<MdAdd size={20} />}
                  outline={true}
                  btnClass={styles.addQuesBtn}
                  onClick={() => {
                    setaddSongModal(true)
                  }}
                />
              </Col>
            </Row>
            <List
              className={styles.listClass}
              grid={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 4,
                xxl: 4,
              }}
              dataSource={songsList}
              renderItem={renderSongsList}

            />
          </>
        }

        <Row onClick={() => { setshowQuestionList(!showQuestionList) }} style={{ cursor: 'pointer' }} className={styles.headingRow}>
          <Col>
            <div>
              <TextComponent textClass={styles.headingNumbers}>
                {ClientSection?.length > 0
                  ? `Questions (${topic?.total_answer_by_client} / ${topic?.total_question})`
                  : ""}
              </TextComponent>

              {showQuestionList ?
                <AiOutlineUpSquare color="#00000" size={20} />
                :
                <AiOutlineDownSquare color="#00000" size={20} />
              }
            </div>
          </Col>
          <Col>
            <TextComponent textClass={styles.smallText}>
              Let’s get connected!
            </TextComponent>
          </Col>
        </Row>
        {showQuestionList &&
          <QuestionSteps
            loading={loading}
            ClientQuestion={questions}
            setQuestions={setQuestions}
            getSection={getSection}
          />
        }
      </Col>

      <Modal
        isModalOpen={addSongModal}
        setIsModalOpen={setaddSongModal}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Add Songs Via"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >
            <Col className={styles.addSongModal}>
              <div onClick={() => {
                console.log("Song Ideas", topic);
                dispatch(PlaylistMiddleware.getSectionPlayList({ id: topic?.id })).then((data) => {
                  setsongIdeas(data)
                  setaddSongModal(false)
                  setsongIdeasModal(true)
                })
              }} className={styles.addSongModalDiv}>
                <GiLoveSong color="#00000" size={70} />
                <TextComponent
                  text={"Song Ideas"}
                  textClass={styles.nameText}
                />
              </div>
              <div onClick={() => { setaddSongModal(false); setsearchYoutubeModal(true) }} className={styles.addSongModalDiv}>
                <AiFillYoutube color="#00000" size={70} />
                <TextComponent
                  text={"Youtube"}
                  textClass={styles.nameText}
                />
              </div>
              <div onClick={() => { connectSpotify() }} className={styles.addSongModalDiv}>
                <BsSpotify color="#00000" size={70} />
                <TextComponent
                  text={"Spotify"}
                  textClass={styles.nameText}
                />
              </div>

            </Col>
          </Space>
        </div>
      </Modal>

      <Modal
        isModalOpen={songIdeasModal}
        setIsModalOpen={setsongIdeasModal}
        closable={true}
        className={styles.youtubeModal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Song Ideas"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >

            <List
              className={styles.listClass}
              grid={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 4,
                xxl: 4,
              }}
              dataSource={songIdeas ? songIdeas : []}
              renderItem={renderSongIdeas}

            />
          </Space>
        </div>
      </Modal>
      <Modal
        isModalOpen={songIdeasListModal}
        setIsModalOpen={setsongIdeasListModal}
        closable={true}
        className={styles.youtubeModal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Song Ideas Songs"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >

            <div
             style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer', flexDirection: 'row' }}
              onClick={() => {
                setisMultiselect(!isMultiselect)
                if (!isMultiselect) {
                  setSelectedPlaylist(playlistSongs)
                } else {
                  setSelectedPlaylist([])
                }
              }}
            >
              <TextComponent
                text={"Select All"}
                textClass={styles.smallText}
              />
              {isMultiselect ?
                <AiFillCheckSquare color="#00000" size={20} />
                :
                <AiOutlineBorder color="#00000" size={20} />
              }
            </div>

            <List
              className={styles.listClass}
              grid={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 4,
                xxl: 4,
              }}
              dataSource={playlistSongs ? playlistSongs : []}
              renderItem={renderSongIdeasList}

            />
            {isUpload ? <Spin size="large" /> :
              isMultiselect &&
              <SubmitButton
                title={'Done'}
                onClick={uploadBulkSongsIdeas}
                style={styles.add_temp_button}
              />

            }
          </Space>
        </div>
      </Modal>

      <Modal
        isModalOpen={searchYoutubeModal}
        setIsModalOpen={setsearchYoutubeModal}
        closable={true}
        className={styles.youtubeModal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Search Songs on Youtube"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >
            <SearchInput
              className={styles.searchInput}
              placeholder={"Search Song"}
              onChange={(e) => SearchYoutube(e.target.value)}
              value={title}
            />
            {isSearch && <Spin size="large" className={styles.searchSpin} />}
            <List
              className={styles.listClass}
              grid={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 4,
                xxl: 4,
              }}
              dataSource={YoutubeSongs}
              renderItem={renderYoutubeSongs}

            />

            <SubmitButton
              title={'Done'}
              onClick={() => { setsearchYoutubeModal(false); setYoutubeSongs([]); setTitle('') }}
              style={styles.add_temp_button}
            />

          </Space>
        </div>
      </Modal>

      <Modal
        isModalOpen={isSpotify}
        setIsModalOpen={setisSpotify}
        closable={true}
        className={styles.youtubeModal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Spotify Playlists"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >

            <List
              className={styles.listClass}
              grid={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 4,
                xxl: 4,
              }}
              dataSource={spotifyPlaylist}
              renderItem={renderSpotifyPlaylists}

            />

            <SubmitButton
              title={'Done'}
              onClick={() => { setisSpotify(false); setSpotifyPlaylist([]) }}
              style={styles.add_temp_button}
            />

          </Space>
        </div>
      </Modal>
      <Modal
        isModalOpen={spotifysongsModal}
        setIsModalOpen={setSpotifySongsModal}
        closable={true}
        className={styles.youtubeModal}
      >
        <div className={styles.modalCon}>
          <TextComponent
            text={"Spotify Songs"}
            textClass={styles.modalHeading}
          />
          <Space
            direction="vertical"
            size="small"
            style={{
              display: "flex",
              marginTop: "10px",
            }}
          >
            <div
              // disabled={isUpload}
              style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer', flexDirection: 'row' }}
              onClick={() => {
                setisMultiselect(!isMultiselect)
                if (!isMultiselect) {
                  setSelectedPlaylist(spotifysongs)
                } else {
                  setSelectedPlaylist([])
                }
              }}
            >
              <TextComponent
                text={"Select All"}
                textClass={styles.smallText}
              />
              {isMultiselect ?
                <AiFillCheckSquare color="#00000" size={20} />
                :
                <AiOutlineBorder color="#00000" size={20} />
              }
            </div>


            <List
              className={styles.listClass}
              grid={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 4,
                xxl: 4,
              }}
              dataSource={spotifysongs}
              renderItem={renderSpotifySongs}

            />
            {isUpload ? <Spin size="large" /> :
              isMultiselect &&
              <SubmitButton
                title={'Done'}
                onClick={uploadBulkSongs}
                style={styles.add_temp_button}
              />
              // <Button
              //     disabled={SelectedPlaylist.length > 0 ? false : true}
              //     onPress={uploadBulkSongs}
              //     title={'Upload'}
              //     style={{ ...styles.button, marginVertical: 10, marginTop: 10, opacity: SelectedPlaylist.length > 0 ? 1 : 0.5 }}
              // />
            }

            {/* <SubmitButton
                                  title={'Done'}
                                  onClick={() => { setSpotifySongsModal(false); setSpotifySongs([]) }}
                                  style={styles.add_temp_button}
                              /> */}

          </Space>
        </div>
      </Modal>
    </Row>
  );
};

export default SinglePlanningForm;
